// extracted by mini-css-extract-plugin
export default {"modal_animation_duration":"200ms","wrapper":"onfido-sdk-ui-Complete-wrapper","icon":"onfido-sdk-ui-Complete-icon"};